import client from '@/store/client'
import qs from 'query-string'
import { parseStringPromise } from 'xml2js'
import parseData from '../util/parsedata'

const createHeaders =  (headers) => {
  const allHeaders =  []
  headers.forEach( header => {
    allHeaders.push( { 
      text: header.text,
      sortable: false,
      value: header.value,
    })
  })
  return allHeaders
}

const getDefaultState = () => {
  return {
    date: '',
    msgName: '',
    promoVersionCode: '',
    msgResults: [],
    totalOnServer: -1,
    createMsgName: '',
    createPromoVCode: '',
    effectiveDate: '',
    selectedPromocode: '',
    editID: '',
    editMSGName: '',
    editPromoVCode: '',
    editEffectiveDate: '',
    editSelectedPromocode: '',
    editMerchantId: '',
    editRetailId: '',
    editRevision: -1,
    editRowStatus: '',
    editStoreCount: '',
    storesInTotalOnServer: -1,
    storesInMSG: [],
    storesNotInTotalOnServer: -1,
    storesNotInMSG: [],
    MSGInStore: [],
    msgCreated: {
      successful: false,
      newID: ''
    },
    promocodes: [],
    tableHeaders: createHeaders([
      {
        text: 'Name',
        value: 'Name'
      },
      {
        text: 'Effective Date',
        value: 'EffectiveDate'
      },
      {
        text: 'Promotion Code',
        value: 'PromotionCode'
      },
      {
        text: 'Version Code',
        value: 'VersionCode'
      },
      {
        text: 'Store Count',
        value: 'Count'
      },
      {
        text: 'MSG ID',
        value: 'ID'
      }
    ])
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    RESET_NEW_MSG: ({commit}) => {
      commit('resetNewMsg',)
    },
    SEARCH_MSG: async function( {commit}, data ) {
      try {
        const dataReq = {
          ...this.getters['msgSearch/findMSGData'],
          recordIndex: data.page,
          RecordsPerPageCount: data.itemsPerPage,
          retailerID: data.retailerid
        }       
        const APIRes = await client.post('/v1/MerchantStoreGroup.asmx/FindMerchantStoreGroup', qs.stringify(dataReq))
        const response = await parseStringPromise(APIRes.data)
        commit('setField', { key: 'totalOnServer', value: +response.content.data[0].$.Count })
        commit('setMSGResults', await parseData(APIRes.data))
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }      
    },
    GET_PROMOCODES: async function({ commit }, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })        
        const APIResults = await client.post('/v1/MerchantStoreGroup.asmx/GetPromotionCodesByRetailerID', qs.stringify({...this.getters['msgSearch/promocodesAPI'], retailerId: data.retailerId}))
        commit('setPromocodes', await parseData(APIResults.data))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Data Received',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })
      }      
    },
    INSERT_MSG: async function({ commit }){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating MSG',
          subdetail: 'Please wait',
        })        
        const APIResults = await client.post('/v1/MerchantStoreGroup.asmx/InsertMerchantStoreGroup', qs.stringify(this.getters['msgSearch/insertMSGData']))
        const parseResults = await parseStringPromise(APIResults.data)
        commit('setMSGCreated', parseResults.content.data[0].$.ID)
        this.dispatch('ui/SET_TOAST', { message: `New MSG created with ID: ${ parseResults.content.data[0].$.ID }`, color: 'green', delay: 2500 })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'MSG Created',
          subdetail: '',
        })       
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: "Could not create MSG",
          subdetail: err.response.data,
        })       
      } 
    },
    GET_MSG: async function({commit}, data) {
      const APIResults = await client.post('/v1/MerchantStoreGroup.asmx/GetMerchantStoreGroup', qs.stringify({...this.getters['traceToken'], msgid: data}))
      const parseResults = await parseStringPromise(APIResults.data)
      commit('setMSG', parseResults.content.collection[0].data[0].$)
    },
    UPDATE_MSG: async function(){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating MSG',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/MerchantStoreGroup.asmx/UpdateMerchantStoreGroup', qs.stringify(this.getters['msgSearch/updateMSGData']))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `MSG successfully updated`, color: 'green', delay: 2500 })
      }
      catch(err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: "Could not update MSG",
          subdetail: err.response.data,
        })       
      }
    },
    SEARCH_STORES_IN_MSG: async function({commit, state}, data){
      try{
        const APIData = {
          ...this.getters['pretailer/searchStoreData'],
          ...data,
          msgID: state.editID
        }
        const storesInMSG = await client.post('/v1/MerchantStoreGroup.asmx/FindStoresInMSG', qs.stringify(APIData))
        const paresdStoresIn = await parseStringPromise(storesInMSG.data)
        commit('setField', { key: 'storesInTotalOnServer', value: +paresdStoresIn.content.collection[0].$.TotalRecordCount })
        commit('setField', { key: 'storesInMSG', value: await parseData(storesInMSG.data) })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    SEARCH_STORES_NOT_IN_MSG: async function({commit, state}, data){
      try{
        const APIData = {
          ...this.getters['pretailer/searchStoreData'],
          ...data,
          msgID: state.editID
        }
        const storesNotInMSG = await client.post('/v1/MerchantStoreGroup.asmx/FindStoresNotInMSG', qs.stringify(APIData))
        const paresdStoresNotIn = await parseStringPromise(storesNotInMSG.data)
        commit('setField', { key: 'storesNotInTotalOnServer', value: +paresdStoresNotIn.content.collection[0].$.TotalRecordCount })
        commit('setField', { key: 'storesNotInMSG', value: await parseData(storesNotInMSG.data) })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ADD_REMOVE_STORE: async function({state}, data){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Store',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...this.getters['traceToken'],
          ...data,
          msgID: state.editID
        }
        await client.post('/v1/MerchantStoreGroup.asmx/AddOrRemoveMSGS', qs.stringify(APIData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Store successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    SEARCH_MSG_IN_STORE: async function({commit}, data){
      try{
        const APIData = {
          ...this.getters['msgSearch/findMSGStore'],
          ...data,
        }
        const MSGinStore = await client.post('/v2/MerchantStoreGroup.asmx/FindMSGStore', qs.stringify(APIData))
        commit('setField', { key: 'MSGInStore', value: await parseData(MSGinStore.data) })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ATTACH_DETACH_MSG: async function({rootGetters}, data){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updateing MSG',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...rootGetters['traceToken'],
          ...data,
        }
        await client.post('/v1/MerchantStoreGroup.asmx/AddOrRemoveMSGS', qs.stringify(APIData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `MSG successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
  },
  getters: {
    findMSGData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        msgName: state.msgName,
        promotionCode: state.promoVersionCode,
        versionCode: '',
        effectiveDate: state.date,
      }
    },
    msgInStoreItems: state => {
      return state.MSGInStore.map( item => {
        if (item.WithStore == 'false') item.WithStore = false
        else item.WithStore = true 
        return item
      })
    },
    findMSGStore: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        msgName: state.msgName,
        PromotionCode: state.promoVersionCode,
        versionCode: '',
        EffectiveDate: state.date,
        MerchantStoreGroupName: state.msgName,
        PromotionVersionCode: state.promoVersionCode
      }
    },
    promocodesAPI: (state, getters, rootState) => {
      return {
        retailerId: rootState.retailer.retailerInfo.ID,
        token: rootState.user.token
      }
    },
    insertMSGData: (state, getters, rootState) => {
      return {
        effictiveDate: state.effectiveDate,
        merchantId: rootState.retailer.retailerInfo.MerchantID || rootState.pretailer.pretailerInfo.MerchantID,
        retailerId: rootState.retailer.retailerInfo.ID || rootState.pretailer.pretailerInfo.RetailerID,
        promotionCode: state.selectedPromocode,
        versionCode: state.createPromoVCode,
        merchantStoreGroupName: state.createMsgName,
        token: rootState.user.token
      }
    },
    updateMSGData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        effictiveDate: state.editEffectiveDate,
        merchantId: state.editMerchantId,
        retailerId: state.editRetailId,
        promotionCode: state.editSelectedPromocode,
        versionCode: state.editPromoVCode,
        merchantStoreGroupName: state.editMSGName,
        MerchantStoreGroupID: state.editID,
        Revision: state.editRevision
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    resetNewMsg: function(state) {
      state.createMsgName = '',
      state.createPromoVCode = '',
      state.effectiveDate = '',
      state.selectedPromocode = '',
      state.msgCreated = {
        successful: false,
        newID: ''
      }  
    },
    setMSGResults: function(state, data) {
      state.msgResults = data
    },
    setPromocodes: function(state, data) {
      state.promocodes = data
    },
    setMSGCreated: function(state, data){
      state.msgCreated.successful = true,
      state.msgCreated.newID = data
    },
    setMSG: function(state, data){
      state.editID = data.ID
      state.editMSGName = data.Name
      state.editPromoVCode = data.VersionCode
      state.editEffectiveDate = data.EffectiveDate.split(" ")[0]
      state.editSelectedPromocode = data.PromotionCode,
      state.editMerchantId = data.MerchantID
      state.editRetailId = data.RetailerID
      state.editRevision = data.Revision,
      state.editRowStatus = data.RowStatus,
      state.editStoreCount = data.Count
    }
  },
}
